import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

import { recoverUserList } from '~/Redux/Modules/UserLists/actions';
import moment from '~/Providers/Moment';
import { DATE_TIME_FORMAT } from '~/Redux/Constants';

import './Toolbar.scss';

const RecoveryModeBanner = ({ current, inRecoveryMode, recoverUserList, time }) => {
  var dateTime = moment
    .tz(time, DATE_TIME_FORMAT)
    .tz(moment.tz.guess())
    .format(DATE_TIME_FORMAT);
  return (
    <div className="recoveryModeBanner">
      Read only, deleted at: {dateTime}
      <div className="right" />
      <button
        onClick={() => recoverUserList(current.id, inRecoveryMode)}
        className="btn btn-default"
      >
        Recover List
      </button>
    </div>
  );
};

const mapStateToProps = ({ UserLists: { lists } }) => {
  return {
    inRecoveryMode: lists.inRecoveryMode,
    current: lists.current,
    time: lists.current.deleted_at,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    recoverUserList: (id, inRecoveryMode) => dispatch(recoverUserList(id, inRecoveryMode)),
  };
};

RecoveryModeBanner.propTypes = {
  inRecoveryMode: propTypes.bool,
  current: propTypes.oneOfType([propTypes.object, propTypes.bool]),
  recoverUserList: propTypes.func,
  time: propTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecoveryModeBanner);
